const LAMPORTS_PER_SOL = 1_000_000_000n;

function toBigInt(v: number | bigint | string): bigint {
  if (typeof v === "bigint") return v;
  if (typeof v === "number") return BigInt(Math.trunc(v));
  return BigInt(v || "0");
}

const grouped = new Intl.NumberFormat("en-US");

/** ₽1,386 */
export function formatRcd(v: number | bigint | string): string {
  const n = toBigInt(v);
  return `${n < 0n ? "−" : ""}₽${grouped.format(n < 0n ? -n : n)}`;
}

/** +₽1,386 / −₽200 */
export function formatRcdDelta(v: number): string {
  if (v === 0) return "₽0";
  return `${v > 0 ? "+" : "−"}₽${grouped.format(Math.abs(v))}`;
}

/** Lamports → "0.0215" SOL, trimmed to `digits` decimals, rounded up so a top-up is enough. */
export function formatSol(lamports: number | bigint | string, digits = 4): string {
  const l = toBigInt(lamports);
  const scale = 10n ** BigInt(digits);
  const scaled = (l * scale + LAMPORTS_PER_SOL - 1n) / LAMPORTS_PER_SOL;
  const whole = scaled / scale;
  const frac = (scaled % scale).toString().padStart(digits, "0").replace(/0+$/, "");
  return frac ? `${whole}.${frac}` : whole.toString();
}

/** "0.05" SOL → lamports as a decimal string. */
export function solToLamports(sol: string): string {
  const s = sol.trim();
  if (!/^\d*(\.\d{0,9})?$/.test(s) || s === "" || s === ".") throw new Error("Enter an amount in SOL, e.g. 0.05");
  const [w = "0", f = ""] = s.split(".");
  return (BigInt(w || "0") * LAMPORTS_PER_SOL + BigInt(f.padEnd(9, "0") || "0")).toString();
}

export function timeAgo(ts: number | null, now = Date.now()): string {
  if (!ts) return "never";
  const s = Math.max(0, Math.round((now - ts) / 1000));
  if (s < 45) return "just now";
  const m = Math.round(s / 60);
  if (m < 60) return `${m} min ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h} h ago`;
  return new Date(ts).toLocaleDateString();
}

export function shortAddress(a: string): string {
  return a.length > 12 ? `${a.slice(0, 4)}…${a.slice(-4)}` : a;
}
